<template>
  <div class="wrapper">
    <div class="jiandang">
      <van-tabs v-model="active" title-active-color="#3C9ECF">
        <van-tab title="无就诊卡">
          <van-form
            @submit="onSubmit1"
            @failed="onFailed1"
            :scroll-to-error="true"
          >
            <van-field
              v-model="queryParams.username"
              name="username"
              label="姓名"
              placeholder="请输入姓名"
              :rules="[{ required: true, message: ' ' }]"
            />
            <van-field
              v-model="queryParams.ID_card"
              maxlength="18"
              name="ID_card"
              clickable
              label="居民身份证"
              placeholder="请输入证件号"
              :rules="[{ validator: validatorId, message: ' ' }]"
            >
              <!-- <template #label>
                <span @click="showID = true" class="IDcl">
                  {{ ID_type }}
                  <van-icon name="arrow-down" />
                </span>
              </template> -->
            </van-field>
            <van-field
              v-model="queryParams.nation"
              name="nation"
              readonly
              clickable
              label="民族"
              right-icon="arrow"
              placeholder="请选择民族"
              :rules="[{ required: true, message: ' ' }]"
              @click="showNation = true"
            />
            <van-field
              v-model="queryParams.area"
              name="area"
              readonly
              clickable
              label="居住地"
              right-icon="arrow"
              placeholder="请选择居住地"
              :rules="[{ required: true, message: ' ' }]"
              @click="showArea = true"
            />
            <van-field
              v-model="queryParams.detailedArea"
              name="detailedArea"
              label="详细地址"
              placeholder="请在此输入详细地址"
              :rules="[{ required: true, message: ' ' }]"
            />
            <van-field
              v-model="queryParams.phone"
              maxlength="11"
              name="phone"
              label="手机号码"
              placeholder="请输入您的手机号码"
              :rules="[{ validator: validatorphone, message: ' ' }]"
            />
            <van-action-sheet
              v-model="showID"
              :actions="actions"
              cancel-text="取消"
              description="选择身份证类型"
              @select="onSelect"
              close-on-click-action
            />
            <van-popup v-model="showNation" round position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirmNation"
                @cancel="showNation = false"
              />
            </van-popup>
            <van-popup v-model="showArea" round position="bottom">
              <van-area
                :area-list="areaList"
                @confirm="onConfirmArea"
                @cancel="showArea = false"
              />
            </van-popup>
            <!-- <div style="margin: 250px 16px 16px;">
              <van-button round block type="info" :disabled="false"
                >立即绑卡</van-button
              >
            </div> -->
            <div class="ljbk">
              <van-button round block type="info" :disabled="false"
                >确认</van-button
              >
            </div>
          </van-form>
        </van-tab>
        <van-tab title="有就诊卡">
          <van-form
            @submit="onSubmit2"
            @failed="onFailed2"
            :scroll-to-error="true"
          >
            <van-field
              v-model="queryParams2.cardno"
              name="cardno"
              label="就诊ID号"
              placeholder="请输入就诊卡号"
              :rules="[{ required: true, message: ' ' }]"
            />
            <van-field
              v-model="queryParams2.idcardno"
              maxlength="18"
              name="ID_card"
              clickable
              label="居民身份证"
              placeholder="请输入证件号"
              :rules="[{ validator: validatorId, message: ' ' }]"
            >
            </van-field>
            <van-field
              v-model="queryParams2.telno"
              maxlength="11"
              name="phone"
              label="手机号码"
              placeholder="请输入您的手机号码"
              :rules="[{ validator: validatorphone, message: ' ' }]"
            />
            <!-- <div style="margin: 470px 16px 16px;">
              <van-button round block type="info" :disabled="false"
                >立即绑卡</van-button
              >
            </div> -->
            <div class="ljbk">
              <van-button round block type="info" :disabled="false"
                >确认</van-button
              >
            </div>
          </van-form>
        </van-tab>
      </van-tabs>
    </div>
    <!-- <span class="typeface">已有健康卡，一键快速关联</span> -->
  </div>
</template>

<script>
import { insert, bind, selectVisitinfos, setStyle } from "@/request/api.js";
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      active: 0,
      queryParams: {
        username: "",
        ID_card: "",
        nation: "",
        area: "",
        detailedArea: "",
        phone: ""
      },
      queryParams2: {
        cardno: "",
        idcardno: "",
        telno: ""
      },
      ID_type: "居民身份证",
      showID: false,
      showArea: false,
      showNation: false,
      areaList: areaList,
      allCards: [],
      columns: [
        "汉族",
        "壮族",
        "满族",
        "回族",
        "苗族",
        "维吾尔族",
        "土家族",
        "彝族",
        "蒙古族",
        "藏族",
        "布依族",
        "侗族",
        "瑶族",
        "朝鲜族",
        "白族",
        "哈尼族",
        "哈萨克族",
        "黎族",
        "傣族",
        "畲族",
        "傈僳族",
        "仡佬族",
        "东乡族",
        "高山族",
        "拉祜族",
        "水族",
        "佤族",
        "纳西族",
        "羌族",
        "土族",
        "仫佬族",
        "锡伯族",
        "柯尔克孜族",
        "达斡尔族",
        "景颇族",
        "毛南族",
        "撒拉族",
        "布朗族",
        "塔吉克族",
        "阿昌族",
        "普米族",
        "鄂温克族",
        "怒族",
        "京族",
        "基诺族",
        "德昂族",
        "保安族",
        "俄罗斯族",
        "裕固族",
        "乌孜别克族",
        "门巴族",
        "鄂伦春族",
        "独龙族",
        "塔塔尔族",
        "赫哲族",
        "珞巴族"
      ],
      actions: [
        { name: "居民身份证", color: "#3270E7" },
        { name: "港澳居民来往内地通行证" },
        { name: "台湾居民来往内地通行证" }
      ],
    };
  },
  async created() {
    let openid = sessionStorage.getItem("openid");
    let res = await selectVisitinfos({ openid });
    this.allCards = res.data.obj;
  },
  mounted() {},
  methods: {
    async onSubmit1() {
      let map = {
        address: this.queryParams.area + this.queryParams.detailedArea,
        idcardno: this.queryParams.ID_card,
        openid: sessionStorage.getItem("openid"),
        patientname: this.queryParams.username,
        style: this.allCards.length == 0?1:0,
        telno: this.queryParams.phone,
        nation: this.queryParams.nation
      };
      console.log(map);
      let res = await insert(map);
      if(res.data.message == "操作成功"){
        this.QueryCardList(1);
      } else {
        this.Toast.fail(res.data.message);
      }
    },
    async onSubmit2(){
      let map = {
        cardno: this.queryParams2.cardno,
        idcardno: this.queryParams2.idcardno,
        telno: this.queryParams2.telno,
        openid: sessionStorage.getItem("openid"),
        style: 0,
      }
      let res = await bind(map);
      if(res.data.message == "绑定成功"){
        // this.Toast.success('绑定成功');
        // this.$router.go(-1);
        this.QueryCardList(2);
      } else {
        this.Toast.fail(res.data.message);
      }
    },
    onFailed1(values) {
      this.Toast("请先完善信息");
      console.log(values);
    },
    onFailed2(values) {
      this.Toast("请先完善信息");
      console.log(values);
    },
    onConfirmArea(values) {
      this.queryParams.area = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("");
      this.showArea = false;
    },
    onSelect(item, index) {
      this.actions.forEach(item => {
        delete item.color;
      });
      this.actions[index].color = "#3270E7";
      this.ID_type = item.name;
      this.showID = false;
    },
    onConfirmNation(value) {
      this.queryParams.nation = value;
      this.showNation = false;
    },
    validatorId(value) {
      let flag = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value);
      if (!flag) {
        this.Toast("请输入正确的身份证号码");
      }
      return flag;
    },
    validatorphone(value) {
      // let flag = /^[1][3,5,7,8][0-9]{9}$/.test(value);
      let flag = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);
      if (!flag) {
        this.Toast("请输入正确的手机号码");
      }
      return flag;
    },
    async QueryCardList(num){
      try {
        let res = await selectVisitinfos({ openid: sessionStorage.getItem("openid") });
        let cardList = res.data.obj;
        let flag = cardList.some(ele => ele.style == 1);
        if(flag){
          if(num == 1){
            this.Toast.success('建卡成功');
          } else {
            this.Toast.success('绑卡成功');
          }
          this.$router.go(-1);
        } else {
          let map = {
            carId: cardList[0].carId,
            openid: sessionStorage.getItem("openid")
          }
          let re = await setStyle(map);
          if(re.data.message == "操作成功"){
            if(num == 1){
              this.Toast.success('建卡成功');
            } else {
              this.Toast.success('绑卡成功');
            }
            this.$router.go(-1);
          }
        }
      } catch (error) {}
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  background-color: #f4f4f6;
  /deep/ .jiandang {
    height: 100%;
    .van-tabs{
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
    }
    .IDcl {
      display: flex;
      align-items: center;
    }
    .van-field__body {
      height: 100%;
    }
    .van-tab--active{
      font-weight: bold;
    }
    .van-tabs__line{
      width: 40px !important;
      background-color: #3C9ECF !important;
    }
    .van-tabs__content{
      margin-top: 10px;
      flex: 1;
      .van-tab__pane{
        height: 100%;
        .van-form{
          position: relative;
          height: 100%;
          .ljbk{
            top: 20px;
            margin: 0px 16px;
            position: relative;
          }
        }
      }
    }
  }
  .typeface {
    display: block;
    width: 100%;
    text-align: center;
    color: #1c96cb;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EstablishArchives/AddVisitors.vue